import './App.css';
import Header from './components/Header/Header';
import "./assets/js/script";
import Services from './components/Services/Services';
import About from './components/About/About';
import Qualities from './components/Qualities/Qualities';
import Features from './components/Features/Features';
import Portfolio from './components/Portfolio/Portfolio';
import Testimonials from './components/Testimonials/Testimonials';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ItemsSection from './components/ItemsSection/ItemSection';

function App() {
  return (
    <div className="App">
      <Header />
      <ItemsSection />
      {/* <Services /> */}
      <About />
      {/* <Qualities /> */}
      {/* <Features />
      <Portfolio />
      <Testimonials /> */}
      {/* <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
